<template>
  <div class="bghover">
    <div>
      <h2>"人努力-天帮忙"指数</h2>
    </div>

    <div style="text-align: left">
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <span style="color: #f56c6c"
              >什么是"人努力-天帮忙"指数？<i
                class="header-icon el-icon-info"
              ></i
            ></span>
          </template>
          <div>
            结合原始污染物浓度与气象调整后的污染物浓度，分解气象和人为因素的影响，计算“人努力—天帮忙”指数
            <br />
            用该年原始浓度与调整后浓度差值相对上一年原始浓度的比率衡量该年气象影响（“天是否帮忙”），
            <span style="color: #f56c6c">正值</span
            >表示气象条件不利，即“天不帮忙”，
            <span style="color: #409eff">负值</span
            >表示气象条件有利，即“天帮忙”；
            <br />
            用连续两年调整后浓度差值相对上一年原始浓度的比率衡量排放水平变化（“人是否努力”），
            <span style="color: #f56c6c">正值</span
            >代表背景浓度上升，即“人不努力”，
            <span style="color: #409eff">负值</span
            >代表背景浓度下降，即“人努力”。
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div style="text-align: left; margin-top: 15px">
      <el-row>
        显示数据：
        <el-radio-group
          v-model="assessPullContent"
          @change="assessPullContentChange"
        >
          <el-radio label="h">“人努力”指数</el-radio>
          <el-radio label="w">“天帮忙”指数</el-radio>
        </el-radio-group>
      </el-row>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div id="city-hw-indexrank-chart-canvas">
      <div>
        <div
          id="city-hw-index-chart"
          :style="{
            height: eleheight + 'px',
          }"
        ></div>
      </div>

      <div>
        <div
          id="city-hw-rank-index-chart"
          :style="{
            height: eleheight + 'px',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  /* margin-bottom: 10px; */
}
</style>

<script>
// // @ is an alias to /src
import { getSeasonZH } from "@/assets/js/my-utils.js";
import { GenerateMapImgFromDom } from "@/assets/js/utils-map.js";

export default {
  name: "Platform",
  data() {
    return {
      eleheight: 320,
      chart: [],
      isMobile: false,
      assessPull: "PM2.5",
      assessPullContent: "h",
      cityname: "",
      cityname_en: "",
      chart_line_data: [],
      // chartName: "cityareahwheatmap",
    };
  },
  components: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("city-hw-indexrank-chart-canvas");

      let title = "各季度“人努力-天帮忙”指数";
      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    drawhwindexCharts() {
      const that = this;
      let index_type = "hindex";
      if (that.assessPullContent == "w") {
        index_type = "windex";
      }
      let axiosPosts = [];
      this.assesscity.forEach((element) => {
        let hasCityData = false;
        for (let i = 0; i < that.chart_line_data.length; i++) {
          if (that.chart_line_data[i].city == element[1]) {
            hasCityData = true;
          }
        }

        if (!hasCityData) {
          let url = "/AQAssess/getCityHWindex/" + element[2] + "/" + this.assessPull + "/"  + index_type;

          axiosPosts.push(
            that.$axios.get(url)
          );
        }
      });

      let line_data = [];

      if (axiosPosts.length > 0) {
        this.$axios.all(axiosPosts).then((res) => {
          res.forEach((re) => {
            
            let city_en = re.config.url.split("/")[3];

            let city = "";
            for (let i = 0; i < that.assesscity.length; i++) {
              if (that.assesscity[i][2] == city_en) {
                city = that.assesscity[i][1];
                break;
              }
            }

            that.chart_line_data.push({
              city: city,
              data: re.data,
            });
          });


          that.assesscity.forEach((element) => {

            for (let i = 0; i < that.chart_line_data.length; i++) {
              if (that.chart_line_data[i].city === element[1]) {
                line_data.push(that.chart_line_data[i]);
              }
            }
          });
          

          that.drawCityHWindexHeatMapsChart(
            that.chart[0],
            line_data,
            that.assessPull,
            that.assessPullContent,
            "index"
          );

          that.drawCityHWindexHeatMapsChart(
            that.chart[1],
            line_data,
            that.assessPull,
            that.assessPullContent,
            "rank"
          );
        });
        // .catch((e) => {
        //   this.$message({
        //     type: "info",
        //     message: "获取污染物浓度排名数据失败",
        //   });
        // });
      } else {
        that.assesscity.forEach((element) => {
          for (let i = 0; i < that.chart_line_data.length; i++) {
            if (that.chart_line_data[i].city === element[1]) {
              line_data.push(that.chart_line_data[i]);
            }
          }
        });

        that.drawCityHWindexHeatMapsChart(
          that.chart[0],
          line_data,
          that.assessPull,
          that.assessPullContent,
          "index"
        );

        that.drawCityHWindexHeatMapsChart(
          that.chart[1],
          line_data,
          that.assessPull,
          that.assessPullContent,
          "rank"
        );
      }
    },
    assessPullContentChange(content) {
      this.assessPullContent = content;
      this.chart_line_data = [];
      this.updateCharts();
    },
    updateCharts() {
      // this.chart[0].showLoading();

      this.chart.forEach((element) => {
        element.showLoading();
      });


      this.drawhwindexCharts();
    },

    drawCityHWindexHeatMapsChart(
      chart,
      data,
      city,
      type = "h",
      content = "rank"
    ) {
      // console.log(data);

      let series = [];
      let axisData = [];
      let seasonZh = ["春", "夏", "秋", "冬"];
      data.forEach((element) => {
        let city = element.city;
        let city_data = element.data;
        let pullData = [];
        let rankData = [];

        element.data.forEach((elem) => {
          if (content == "rank") {
            pullData.push([elem[1] + seasonZh[elem[2] - 1], elem[4]]);
          } else {
            pullData.push([
              elem[1] + seasonZh[elem[2] - 1],
              (100 * parseFloat(elem[3])).toFixed(1),
            ]);
          }

          axisData.push(elem[1] + "" + (elem[2] - 1));
        });
        let hasCity = false;
        for (let i = 0; i < series.length; i++) {
          if (series[i].name == element.city) {
            hasCity = true;
            break;
          }
        }

        if (!hasCity) {
          series.push({
            name: element.city,
            type: content == "rank" ? "bar" : "line",
            symbolSize: 10,
            label: {
              show: true,
              position: "top",
            },
            edgeSymbol: ["circle", "arrow"],
            edgeSymbolSize: [4, 10],
            data: pullData,
          });
        }
      });

      axisData = Array.from(new Set(axisData));
      axisData = axisData.sort((a, b) => {
        let a_year = a.substring(0, 4);
        let a_season = a.substring(4, 5);

        let b_year = b.substring(0, 4);
        let b_season = b.substring(4, 5);
        // console.log(a_season);

        if (a_year > b_year) {
          return 1;
        } else if (a_year == b_year) {
          if (a_season < b_season) {
            return -1;
          } else {
            return 1;
          }
        }

        return -1;
      });

      let axisDataZH = [];
      axisData.forEach((element) => {
        let year = element.substring(0, 4);
        let season = element.substring(4, 5);
        axisDataZH.push(year + "" + seasonZh[season]);
      });

      // 展示的年份数量
      let endValue = 1;
      for (endValue = 1; endValue < 24; endValue++) {
        if (endValue * data.length > 30) {
          break;
        }
      }
      let title;
      let sub_title;
      if (type == "h") {
        title = "各季度“人努力”指数";
        sub_title = "数值越小，“人努力”程度越高";
      } else {
        title = "各季度“天努力”指数";
        sub_title = "数值越小，“天帮忙”程度越高";
      }

      if (content == "rank") {
        title = title + "排名";
      }

      let option = {
        title: {
          text: title,
          subtext: sub_title,
          left: "center",
          padding: 25,
          subtextStyle: {
            color: "#F56C6C",
            fontSize: "14",
          },
        },
        grid: {
          top: 100 + data.length * 2,
          left: 30,
          right: 20,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          position: "right",
        },
        legend: { top: 70, right: "center" },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: axisDataZH,
          axisLabel: {
            rotate: 0,
          },
        },
        yAxis: {
          type: "value",
          name: content == "rank" ? "排名" : "指数",
          nameLocation: "middle",
          nameTextStyle: {
            padding: 15,
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            startValue: axisDataZH.length - endValue,
            endValue: axisDataZH.length,
          },
        ],
        series: series,
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;
      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("city-hw-index-chart"))
        );

        this.chart.push(
          this.$echarts.init(
            document.getElementById("city-hw-rank-index-chart")
          )
        );

        this.chart.forEach((element) => {
          element.showLoading();
        });

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("city-hw-index-chart"))
      );

      this.chart.push(
        this.$echarts.init(document.getElementById("city-hw-rank-index-chart"))
      );

      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.updateCharts();
    }
    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
};
</script>
